import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Avatar } from './UI';

const NAV_USER = [
  { path: '/dashboard',           label: 'Dashboard',    icon: '⊞' },
  { path: '/dashboard/earnings',  label: 'Earnings',     icon: '💰' },
  { path: '/dashboard/activity',  label: 'Activity',     icon: '🕐' },
  { path: '/dashboard/withdraw',  label: 'Withdraw',     icon: '🏦' },
  { path: '/dashboard/platforms', label: 'My Platforms', icon: '🔗' },
  { path: '/dashboard/settings',  label: 'Settings',     icon: '⚙' },
];

const NAV_ADMIN = [
  { path: '/admin',                   label: 'Overview',          icon: '⊞' },
  { path: '/admin/users',             label: 'Users',             icon: '👥' },
  { path: '/admin/earnings',          label: 'Earnings',          icon: '💰' },
  { path: '/admin/withdrawals',       label: 'Withdrawals',       icon: '🏦' },
  { path: '/admin/platform-accounts', label: 'Platform Accounts', icon: '🔐' },
  { path: '/admin/activity',          label: 'Activity Log',      icon: '🕐' },
  { path: '/admin/referrals',         label: 'Referrals', icon: '🔗' },
];

function getGreeting() {
  const h = new Date().getHours();
  return h < 12 ? 'Good morning' : h < 17 ? 'Good afternoon' : 'Good evening';
}

export default function Layout({ children }) {
  const { user, logout, isAdmin } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navItems = isAdmin ? NAV_ADMIN : NAV_USER;

  function handleLogout() { logout(); navigate('/login'); }
  function close() { setSidebarOpen(false); }

  const Sidebar = () => (
    <div style={{ display:'flex', flexDirection:'column', height:'100%' }}>
      <div style={{ padding:'20px 20px 16px', borderBottom:'1px solid #f0f2f8', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <Link to={isAdmin?'/admin':'/dashboard'} style={{ textDecoration:'none' }} onClick={close}>
          <span style={{ fontFamily:"'Sora',sans-serif", fontSize:20, fontWeight:700, color:'#1a1f5e' }}>
            Qu<span style={{ color:'#4f6ef7' }}>vera</span>
          </span>
        </Link>
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          {isAdmin && <span style={{ background:'#fee2e2', color:'#dc2626', fontSize:10, fontWeight:700, padding:'2px 8px', borderRadius:20 }}>ADMIN</span>}
          <button onClick={close} style={{ background:'#f0f2f8', border:'none', borderRadius:8, width:30, height:30, cursor:'pointer', fontSize:18, lineHeight:1, display:'none' }} className="sidebar-close-btn">×</button>
        </div>
      </div>

      <nav style={{ flex:1, padding:'16px 12px', overflowY:'auto' }}>
        {navItems.map(item => {
          const active = location.pathname === item.path;
          return (
            <Link key={item.path} to={item.path} onClick={close} style={{
              display:'flex', alignItems:'center', gap:10,
              padding:'11px 12px', borderRadius:8, marginBottom:2,
              textDecoration:'none', fontSize:14,
              fontWeight: active ? 600 : 500,
              background: active ? '#eef1ff' : 'transparent',
              color: active ? '#4f6ef7' : '#636b89',
              transition:'all .15s',
            }}>
              <span style={{ fontSize:17, flexShrink:0 }}>{item.icon}</span>
              {item.label}
            </Link>
          );
        })}
      </nav>

      <div style={{ padding:'12px', borderTop:'1px solid #f0f2f8' }}>
        <div style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 12px', borderRadius:10 }}>
          <Avatar name={user?.name||''} size={34} />
          <div style={{ flex:1, overflow:'hidden' }}>
            <div style={{ fontSize:13, fontWeight:600, color:'#1a1f5e', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{user?.name}</div>
            <div style={{ fontSize:11, color:'#9099b4', textTransform:'capitalize' }}>{user?.role}</div>
          </div>
          <button onClick={handleLogout} title="Log out" style={{ background:'#f0f2f8', border:'none', borderRadius:6, padding:'5px 10px', fontSize:13, cursor:'pointer', color:'#636b89', flexShrink:0 }}>↩</button>
        </div>
      </div>
    </div>
  );

  return (
    <div style={{ display:'flex', minHeight:'100vh', background:'#f8f9fc', fontFamily:"'DM Sans',sans-serif" }}>

      {/* Desktop sidebar */}
      <aside style={{ width:240, flexShrink:0, background:'#fff', borderRight:'1px solid #e2e6f0', position:'fixed', top:0, left:0, bottom:0, zIndex:50, overflowY:'auto', display:'flex', flexDirection:'column' }} className="desktop-sidebar">
        <Sidebar />
      </aside>

      {/* Mobile overlay */}
      {sidebarOpen && (
        <div onClick={close} style={{ position:'fixed', inset:0, background:'rgba(15,18,51,.55)', zIndex:198, backdropFilter:'blur(2px)' }} />
      )}

      {/* Mobile sidebar */}
      <aside style={{ width:260, background:'#fff', position:'fixed', top:0, left:0, bottom:0, zIndex:199, overflowY:'auto', display:'flex', flexDirection:'column', transform: sidebarOpen?'translateX(0)':'translateX(-100%)', transition:'transform 0.25s ease', boxShadow: sidebarOpen?'4px 0 24px rgba(15,18,51,.18)':'none' }} className="mobile-sidebar">
        <div style={{ padding:'16px 20px 12px', borderBottom:'1px solid #f0f2f8', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
          <span style={{ fontFamily:"'Sora',sans-serif", fontSize:20, fontWeight:700, color:'#1a1f5e' }}>Qu<span style={{ color:'#4f6ef7' }}>Vera</span></span>
          <button onClick={close} style={{ background:'#f0f2f8', border:'none', borderRadius:8, width:34, height:34, cursor:'pointer', fontSize:20, display:'flex', alignItems:'center', justifyContent:'center' }}>×</button>
        </div>
        <nav style={{ flex:1, padding:'16px 12px', overflowY:'auto' }}>
          {navItems.map(item => {
            const active = location.pathname === item.path;
            return (
              <Link key={item.path} to={item.path} onClick={close} style={{ display:'flex', alignItems:'center', gap:10, padding:'13px 12px', borderRadius:8, marginBottom:4, textDecoration:'none', fontSize:15, fontWeight:active?600:500, background:active?'#eef1ff':'transparent', color:active?'#4f6ef7':'#636b89' }}>
                <span style={{ fontSize:19, flexShrink:0 }}>{item.icon}</span>
                {item.label}
              </Link>
            );
          })}
        </nav>
        <div style={{ padding:'12px', borderTop:'1px solid #f0f2f8' }}>
          <div style={{ display:'flex', alignItems:'center', gap:10, padding:'12px' }}>
            <Avatar name={user?.name||''} size={38} />
            <div style={{ flex:1 }}>
              <div style={{ fontSize:14, fontWeight:600, color:'#1a1f5e' }}>{user?.name}</div>
              <div style={{ fontSize:12, color:'#9099b4' }}>{user?.email}</div>
            </div>
          </div>
          <button onClick={handleLogout} style={{ width:'100%', padding:'11px', background:'#fee2e2', color:'#dc2626', border:'none', borderRadius:10, fontSize:14, fontWeight:600, cursor:'pointer', marginTop:4 }}>
            Log Out
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main style={{ marginLeft:240, flex:1, minHeight:'100vh', display:'flex', flexDirection:'column', transition:'margin .25s' }} className="dash-main-content">

        {/* Mobile topbar */}
        <div style={{ display:'none', height:56, background:'#fff', borderBottom:'1px solid #e2e6f0', alignItems:'center', justifyContent:'space-between', padding:'0 16px', position:'sticky', top:0, zIndex:40 }} className="mobile-top-bar">
          <button onClick={()=>setSidebarOpen(true)} style={{ background:'#f0f2f8', border:'none', borderRadius:8, width:40, height:40, cursor:'pointer', fontSize:20, display:'flex', alignItems:'center', justifyContent:'center' }}>☰</button>
          <span style={{ fontFamily:"'Sora',sans-serif", fontSize:18, fontWeight:700, color:'#1a1f5e' }}>Qu<span style={{ color:'#4f6ef7' }}>vera</span></span>
          <Avatar name={user?.name||''} size={36} />
        </div>

        {/* Desktop topbar */}
        <div style={{ height:64, background:'#fff', borderBottom:'1px solid #e2e6f0', display:'flex', alignItems:'center', justifyContent:'space-between', padding:'0 28px', position:'sticky', top:0, zIndex:40 }} className="desktop-top-bar">
          <div>
            <div style={{ fontFamily:"'Sora',sans-serif", fontSize:15, fontWeight:600, color:'#1a1f5e' }}>{getGreeting()}, {user?.name?.split(' ')[0]} 👋</div>
            <div style={{ fontSize:12, color:'#9099b4' }}>{new Date().toLocaleDateString('en-US',{weekday:'long',month:'long',day:'numeric'})}</div>
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:14 }}>
            <div style={{ background:'#eef1ff', color:'#4f6ef7', padding:'7px 16px', borderRadius:20, fontSize:13, fontWeight:700, border:'1px solid rgba(79,110,247,.15)' }}>
              {isAdmin ? '🔐 Admin Mode' : `${user?.name?.split(' ')[0]}'s Account`}
            </div>
            <Avatar name={user?.name||''} size={36} />
          </div>
        </div>

        <div style={{ flex:1 }}>{children}</div>
      </main>

      <style>{`
        @media (max-width: 768px) {
          .desktop-sidebar   { display: none !important; }
          .dash-main-content { margin-left: 0 !important; }
          .mobile-top-bar    { display: flex !important; }
          .desktop-top-bar   { display: none !important; }
        }
      `}</style>
    </div>
  );
}
